import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import VueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/css/swiper.css';
import '@/styles/index.scss';
import '@/styles/reset.css';
import './permission';
import '@/filter';
import '@/directives';
import '@/utils/variables';
import echarts from 'echarts';

import { Form, FormItem, Input, Button, Carousel, CarouselItem } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
let element = {
  Form: Form,
  FormItem: FormItem,
  Input: Input,
  Button: Button,
  Carousel: Carousel,
  CarouselItem: CarouselItem
};

for (let item in element) {
  Vue.use(element[item]);
}
// Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
